module.exports = __webpack_public_path__ + "static/media/Уведомление за Поверителност за Клиентите.2db43acf.pdf";